import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";  // 确保正确导入 TypeScript 版本的 App.tsx
import "./index.css"; // 如果有全局样式文件的话

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
